import React from 'react'
import TaskDetails from '../Layout/Project/details/task'

const TaskDetailsPage = () => {
  return <TaskDetails />
}

export default TaskDetailsPage
